import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function BackButton() {
  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed top-20 sm:top-24 left-3 sm:left-6 z-40"
    >
      <Link
        to="/"
       className="group flex items-center space-x-2 bg-white hover:bg-gray-50 px-4 py-3 rounded-lg border border-gray-200 hover:border-[#d4a10d] transition-all duration-200 shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#d4a10d] focus:ring-offset-2 min-h-[48px]"
      >
        <ArrowLeft className="w-4 h-4 sm:w-5 sm:h-5 text-[#d4a10d] group-hover:-translate-x-1 transition-transform" />
        <span className="text-gray-900 font-semibold text-sm sm:text-base">Back</span>
      </Link>
    </motion.div>
  );
}